import React, { PropsWithChildren, ReactNode, useState } from 'react';
import { makeStyles } from '@material-ui/core';

interface TooltipProps {
  content: ReactNode;
  style?: React.CSSProperties;
  tooltipStyle?: React.CSSProperties;
}

const useStyles = makeStyles(() => ({
  tooltip: {
    position: 'absolute',
    bottom: '120%',
    left: '-100%',
    transform: 'translateX(100%)',
    color: '#FAFAFA',
    zIndex: 99,
    display: 'flex',
    width: '100%',
    padding: '8px 16px',
    borderRadius: '8px',
    background: '#656569',
    fontSize: '13px',
  },
}));

export const Tooltip: React.FC<PropsWithChildren<TooltipProps>> = ({
  content,
  style,
  children,
  tooltipStyle,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const styles = useStyles();
  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        display: 'inline-block',
        color: '#ABABAB',
        marginRight: '4px',
        paddingTop: '2px',
        ...style,
      }}
    >
      {children}
      {showTooltip && (
        <div className={styles.tooltip} style={tooltipStyle}>
          {content}
        </div>
      )}
    </div>
  );
};
